module.exports = __webpack_public_path__ + "static/story4-thumbnails-rect-250x125-0f54db91aa3364a9ff0de9981bd67a2a.jpg";